export default __webpack_public_path__ + "static/media/mini-blog-tablet.6ef87ed0.png";